import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

//get All expense Forms
export const getAdjustment = createAsyncThunk('adjustmentTypeSlice/getAdjustment', async () => {
    try {
        let response = await axios.get('/adjustment-type', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form by Id
export const getAdjustmentById = createAsyncThunk('adjustmentTypeSlice/getAdjustmentById', async (id) => {
    try {
        let response = await axios.get(`/adjustment-type/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form Category Options
export const getAdjustmentOptions = createAsyncThunk('adjustmentTypeSlice/getAdjustmentOptions', async () => {
    try {
        let response = await axios.get(`/adjustment-type/options`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Create Machinery
export const createAdjustment = createAsyncThunk('adjustmentTypeSlice/createAdjustment', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.post(`/adjustment-type`, data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery added successfully.');
        dispatch(getAdjustment());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Edit Machinery
export const updateAdjustment = createAsyncThunk('adjustmentTypeSlice/updateAdjustment', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/adjustment-type/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery updated successfully.');
        dispatch(getAdjustment());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


//Edit Machinery Type Status
export const updateAdjustmentTypeStatus = createAsyncThunk('adjustmentTypeSlice/updateAdjustmentTypeStatus', async (id, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/adjustment-type/status/' + id, {
            loader: false
        });
        toast.success(response?.data?.message || 'Machinery updated successfully.');
        dispatch(getAdjustment());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


export const deleteAdjustmentType = createAsyncThunk('adjustmentTypeSlice/deleteAdjustmentType', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/adjustment-type/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery Type deleted successfully.');
        await dispatch(getAdjustment());

        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const adjustmentTypeSlice = createSlice({
    name: 'adjustmentTypeSlice',
    initialState: {
        data: [],
        selectedAdjutmentType: {},
        adjustmentOptions: {}
    },
    extraReducers: (builder) => {
        builder.addCase(getAdjustment.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getAdjustmentById.fulfilled, (state, action) => {
            state.selectedAdjutmentType = action?.payload;
            return;
        });
        builder.addCase(getAdjustmentOptions.fulfilled, (state, action) => {
            state.adjustmentOptions = action?.payload;
            return;
        });
    }
});

export default adjustmentTypeSlice.reducer;
